// extracted by mini-css-extract-plugin
module.exports = {"icon":"LoginForm_icon__3A9es","mb1":"LoginForm_mb1__3Z-Gx","mb2":"LoginForm_mb2__oxtqK"};